import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_DETAILS_BY_PARAM, CANDIDATE_PROJECTS, CANDIDATE_PROJECTS_PARAM } from "../../../common/URLs";


export const fetchProjects = async () => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_DETAILS_BY_PARAM}?${CANDIDATE_PROJECTS_PARAM}`; // Proxy path
  try {
    const token = await fetchToken()
    
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ` + token,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addProjects = async (newProject) => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_PROJECTS}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newProject),
    });
    const data = await response.json(); 
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const deleteProject = async (uuid) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_PROJECTS}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error deleting job title: " + response.statusText);
    }
    return await response.json();
  } catch (error) {
    throw new Error("Error deleting job title: " + error.message);
  }
};

export const updateProject = async (uuid, projectData) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_PROJECTS}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(projectData),
    });

    // console.log("jobtitle", projectData);

    if (!response.ok) {
      throw new Error("Error updating job project: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job project: " + error.message);
  }
};
